var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2666 19.9724H21.405V14.8619C21.405 14.2798 20.9314 13.8062 20.3493 13.8062H17.4719C16.8898 13.8062 16.4162 14.2798 16.4162 14.8619V19.9723H14.4944V3.61673C14.4944 3.03459 14.0207 2.56104 13.4386 2.56104H10.5613C9.97914 2.56104 9.50554 3.03463 9.50554 3.61673V19.9723H7.69992V9.97273C7.69992 9.39063 7.22628 8.91703 6.64418 8.91703H3.76688C3.18478 8.91703 2.71114 9.39063 2.71114 9.97273V19.9724H1.73334C1.32832 19.9724 1 20.3007 1 20.7057C1 21.1107 1.32832 21.439 1.73334 21.439H22.2666C22.6716 21.439 23 21.1107 23 20.7057C23 20.3007 22.6716 19.9724 22.2666 19.9724Z",
    fill: "#8B857E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/Statistics.396901787a048e57a027baff93068346.svg";
export { ForwardRef as ReactComponent };